// src/handlers/maintenanceHandlers.js
// Maintenance and settings operations
import * as SupabaseService from '../supabaseService';

export const createMaintenanceHandlers = (state) => {
  const {
    setKegs,
    setSettings,
    selectedMaintenanceKeg, setSelectedMaintenanceKeg,
    maintenanceForm, setMaintenanceForm,
    setShowMaintenanceModal
  } = state;

  const handleSaveMaintenance = async () => {
    if (!selectedMaintenanceKeg || maintenanceForm.items.length === 0) return;

    const result = await SupabaseService.addMaintenanceRecord(selectedMaintenanceKeg.id, {
      date: maintenanceForm.date,
      items: maintenanceForm.items
    });

    if (result.success) {
      const kegsResult = await SupabaseService.fetchKegs();
      if (kegsResult.success !== false) {
        setKegs(kegsResult);
      }
      
      setShowMaintenanceModal(false);
      setSelectedMaintenanceKeg(null);
      setMaintenanceForm({ date: new Date().toISOString().split('T')[0], items: [] });
    } else {
      alert('Error saving maintenance: ' + result.error);
    }
  };

  const handleUpdateSettings = async (newSettings) => {
    const result = await SupabaseService.updateSettings(newSettings);
    
    if (result.success) {
      setSettings(newSettings);
    } else {
      alert('Error updating settings: ' + result.error);
    }
  };

  // Location-level maintenance (e.g., Line Cleaning)
  const handleSaveLocationMaintenance = async (breweryId, locationName, sublocationName = null, items = [], notes = '') => {
    if (!breweryId || !locationName || items.length === 0) return;

    const result = await SupabaseService.recordLocationMaintenance(breweryId, locationName, sublocationName, items, notes);
    if (result.success) {
      // Optionally refresh any UI that shows tap_line_status or audits
      return { success: true };
    } else {
      alert('Error saving location maintenance: ' + result.error);
      return { success: false };
    }
  };

  return {
    handleSaveMaintenance,
    handleUpdateSettings,
    handleSaveLocationMaintenance
  };
};